<template>
  <div class="checkout-watches">
    <h2 class="title">{{ $t('checkout.cartOverview.additionalOfferingTitle') }}</h2>
    <ec-carousel>
      <ec-carousel-slide v-for="product in $props.products"
                         :key="product.code">
        <device-item :product="product"
                     :segment="$props.segment"
                     is-additional-offering
                     has-specification
                     class="additional-offering-item"
                     @add-to-cart="handleAddToCart($event, product)"
                     @open-specification="handleOpenSpecification(product)"/>
      </ec-carousel-slide>
    </ec-carousel>
  </div>
</template>

<script>
import { EcCarousel, EcCarouselSlide } from '../../base/mini-carousel/'
import DeviceItem from '../../plp/device-item'
import { getCookie } from '../../../utils/cookieController'
import { addProductToCart } from '../../../api/cart'
import checkoutDataLayer from '../mixins/checkoutDataLayer'

export default {
  name: 'checkout-cart-watches',
  components: { DeviceItem, EcCarouselSlide, EcCarousel },
  mixins: [checkoutDataLayer],
  props: {
    products: {
      type: Array,
      default: () => []
    },
    segment: {
      type: String,
      default: 'PRIVATNI'
    }
  },
  methods: {
    handleAddToCart (color, product) {
      const guid = getCookie('guid')
      const dataToSend = {
        cartId: guid || 'new',
        pricePlanId: product.productOfferingPrices[0].id,
        variantProductCode: color.code || product.tmaPoVariantOptions[0].code,
        fromCheckout: true
      }
      this.$loader.show()
      addProductToCart(dataToSend)
        .then(() => {
          this.$emit('refresh-cart', true)
          this.additionalDevicesDataLayer(product, color)
        })
        .catch(e => {
          this.toast('error', {
            message: this.$t('errors.defaultError')
          })
        })
        .finally(() => {
          this.$loader.hide()
        })
    },
    handleOpenSpecification (product) {
      this.$emit('open-specification', product)
    }
  }
}
</script>

<style scoped lang="scss">
.checkout-watches {
  margin-bottom: 4rem;

  .title {
    font-size: 2rem;
    text-align: center;
    font-weight: normal;
    margin-bottom: 2.4rem;

    @media (map_get($breakpoints, sm)) {
      font-size: 2.4rem;
    }
  }
}

.additional-offering-item {
  margin: 0;
  width: 100%;
  border-radius: 5px;
  padding: 1.6rem 2.4rem;
}
</style>
